import { useState, useMemo } from 'react'
import {
  toDateOnly,
  addDays,
  toIsoDate,
  getInitialAnchor,
} from '../../worker-calendar/model/useWorkerCalendarDays'

export function useLocalCalendarDays() {
  const today = toDateOnly(new Date())
  const [anchor, setAnchor] = useState<Date>(() => getInitialAnchor(today))

  const days = useMemo(() => [anchor, addDays(anchor, 1), addDays(anchor, 2)], [anchor])

  const from = useMemo(
    () => new Date(days[0].getFullYear(), days[0].getMonth(), days[0].getDate(), 0, 0, 0, 0).toISOString(),
    [days],
  )
  const to = useMemo(
    () => new Date(days[2].getFullYear(), days[2].getMonth(), days[2].getDate(), 23, 59, 59, 999).toISOString(),
    [days],
  )

  const todayIso = toIsoDate(today)
  const dayIsos = days.map(toIsoDate)

  function next() {
    setAnchor(addDays(anchor, 3))
  }

  function prev() {
    setAnchor(addDays(anchor, -3))
  }

  function goToToday() {
    setAnchor(getInitialAnchor(today))
  }

  return { days, dayIsos, from, to, todayIso, prev, next, goToToday }
}
